import { Play } from 'lucide-react';

import { NodeShell } from './NodeShell';

export const StartNode = ({ data, selected }: { data: { label: string }; selected?: boolean }) => (
  <NodeShell
    type="start"
    icon={<Play size={16} />}
    label={data.label}
    selected={selected}
    round
    hasTarget={false}
  />
);
